// extracted by mini-css-extract-plugin
export default {"todoListWrap":"TodoListWrap_todoListWrap__G-VVW"};